import Request from './request';
import cookies from 'vue-cookies';
// #region 这部分可以单独抽到一个文件进行管理
let BASE_URL = '';
const TIME_OUT = 1000000;
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'development') {
  BASE_URL = '/api';
} else if (process.env.NODE_ENV === 'production') {
  BASE_URL = '/api';
} else {
  BASE_URL = '/api';
}
// #endregion
const request = new Request({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    // 'token': cookies.get('token'),
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Content-Type',
  },
}).instance;

export default request;
